import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button, Paper, Typography, CircularProgress
} from '@mui/material';
import { Box } from '@mui/system';
import { Add } from '@mui/icons-material';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import { ROUTE_DB_USERS, ROUTE_SYSTEM_USER_REPORTS } from '../routes/Routes';
import { useAuth } from '../hooks/useAuth';
import { sortRegions } from "../util/_helpers";
import GetFetch from '../hooks/GetFetch';
import ClosingAlert from '../components/ClosingAlert';
import DataGridSysUsers from './DataGridSysUsers';
import DataGridDetailedSysUsers from './DataGridDetailedSysUsers';


const SystemUserReports = () => {
    const title = ROUTE_SYSTEM_USER_REPORTS.title;
    const navigate = useNavigate();
    const { user } = useAuth();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    useEffect(() => {
        document.title = title;
        const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page == "ROUTE_SYSTEM_USER_REPORTS") })
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const { Errors, Message, Success } = await GetFetch(
            '/v1/SystemUser/DetailedReport'
        );
        if (Success === true) {
            setData(Message);
            setError(false);
            setErrorMessage(null);
        }
        else {
            setError(true);
            setErrorMessage(Errors[0].Message);
            handleSettingData(null);
            console.error("What went wrong:", Errors);
        }
        setLoading(false);
    };


    return (
        <div>
            <Typography
                className="title-system-user-reports"
                component="div"
            >
                <h1 style={{ color: "#06152B" }}> {title} </h1>
            </Typography>
            {
                (data) &&
                <Box sx={{
                    height: 600
                    , width: '97%'
                    , margin: 'auto'
                }}
                >
                    <Paper
                        elevation={5}
                        sx={{ padding: '30px', marginTop: '7px' }}
                    >
                        <TabPanel id="tab-panel">
                            <Item title="System User Accounts" id="system-user-accounts-tab" aria-label="system-user-accounts-tab">
                                <DataGridSysUsers
                                    data={data}
                                />
                            </Item>
                                <Item title="Detailed System User Accounts" id="detailed-system-user-accounts-tab" aria-label="detailed-system-user-accounts-tab">
                                    <DataGridDetailedSysUsers
                                    data={data}
                                />
                            </Item>
                        </TabPanel>
                    </Paper>
                </Box>
            }
            <ClosingAlert
                severity="error"
                message={errorMessage}
                visible={error && !loading}
                hideAlert={() => { setError(false) }}
            />
            {
                (loading) &&
                <CircularProgress color="secondary" />
            }
        </div>
    );
};

export default SystemUserReports;